// extracted by mini-css-extract-plugin
export default {"blogImage":"PFSBlogEdit_blogImage__SIBJN","icons":"PFSBlogEdit_icons__5ioZq","editor":"PFSBlogEdit_editor__jSCYc","ButtonContainer":"PFSBlogEdit_ButtonContainer__ppEzU"};